/**
 * Centralized set of routes that require authentication.
 */
export const PROTECTED_ROUTES = [
  '/lk/personal-information',
  '/lk/activation-history',
  '/lk/loyalty-history',
  '/lk/replenishment-stories',
  '/lk/safety',
  '/lk/addresses',
  '/lk/PersonalLoyalty',
  '/profile',
  '/favorites',
  '/notifications',
] as const

export const isProtectedRoute = (path: string): boolean => {
  return PROTECTED_ROUTES.some(route => path === route || path.startsWith(`${route}/`))
}

export const PUBLIC_ROUTES = [
  '/',
  '/lk',
  '/policy',
  '/privacy',
  '/success',
  '/fail',
  '/order',
  '/logInYandex',
  '/verifyEmail',
  '/reset-password',
  '/app-redirect',
  '/debug-push',
] as const

export const isPublicRoute = (path: string): boolean => {
  return PUBLIC_ROUTES.some(route => {
    if (route === '/lk') return path === '/lk'
    return path === route || path.startsWith(`${route}/`)
  })
}

export const requiresAuth = (path: string): boolean => {
  if (isPublicRoute(path)) return false
  if (isProtectedRoute(path)) return true
  return false
}
